import { Component, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Section } from "../../draggable/types";
import { ComponentStore, tapResponse } from "@ngrx/component-store";
import { defaultSections } from "../toe-report-template-edit/default-structure";
import { switchMap, withLatestFrom } from "rxjs/operators";
import * as _ from "lodash";
import { ToeReportTemplateFormComponent } from "../toe-report-template-form/toe-report-template-form.component";
import { of } from "rxjs";
import { ToeReportTemplateService } from "../toe-report-template.service";

interface State {
  sections: Section[],
  updatedSections: Section[]
}

@Component({
  selector: 'kt-toe-report-template-edit-modal',
  templateUrl: './toe-report-template-edit-modal.component.html',
  providers: [ComponentStore]
})
export class ToeReportTemplateEditModalComponent {
  @ViewChild(ToeReportTemplateFormComponent) formComponent: ToeReportTemplateFormComponent
  sections$ = this.componentStore.select(state => state.sections)
  constructor(
    private dialogRef: MatDialogRef<ToeReportTemplateEditModalComponent>,
    private componentStore: ComponentStore<State>,
    private service: ToeReportTemplateService
  ) {
    this.componentStore.setState({
      sections: defaultSections,
      updatedSections: defaultSections
    })
  }

  onClose() {
    this.dialogRef.close()
  }
  onSectionsChanged(sections: Section[]) {
    this.componentStore.patchState({updatedSections: sections})
  }
  onSubmit() {
    this.submit()
  }
  private readonly submit = this.componentStore.effect<void>(trigger$ => 
    trigger$.pipe(
      withLatestFrom(this.componentStore.state$),
      switchMap(([_, state]: [void, State]) => {
        if (!this.formComponent) return of();
        const validation = this.formComponent.validate()
        if (validation === 'invalid') return of();
        const payload = this.formComponent.preparePayload(state.updatedSections)
        return this.service.create(payload).pipe(
          tapResponse(
            (res) => {
              this.dialogRef.close(res.data)
            },
            (err) => console.error(err)
          )
        )
      })
    )
  )
}